import {observer} from "mobx-react-lite";
import React, {useEffect, useRef, useState} from 'react';
import {toast} from "react-toastify";
import api from "../../../api/api";
import {useStore} from "../../../hooks/useStore";
import InputBox from "./input_box";
import classNames from "classnames";
import s from './styles.module.css';
import {Tooltip} from "@mui/material";

const FigureBox2 = observer(({
                                 id,
                                 socketData,
                                 judgleStatus,
                                 setOpenDialogCustom,
                                 setCoachTypeId,
                                 setCoachTypeNumber
                             }) => {

    const {figure} = useStore();
    const [figureData, setFigureData] = useState(figure);
    const [updateInput, setUpdateInput] = useState(false);

    const blockRefs = useRef([]);

    const scrollToProcessingUser = () => {
        figureData?.figure?.forEach((fig, ind_box) => {
            const container = blockRefs.current[ind_box];
            if (!container) return;

            // 👉 НОВАЯ ЛОГИКА
            const processingUser = fig.currentDraw != null
                ? fig.users?.find(user => user.draw === fig.currentDraw)
                : fig.users?.find(user => user.is_processing_discipline_figure_id != null);

            if (processingUser) {
                const userElement = container.querySelector(`[data-user-id="${processingUser.user_id}"]`);

                if (userElement) {
                    const offset = 65;

                    const userTop = userElement.getBoundingClientRect().top;
                    const containerTop = container.getBoundingClientRect().top;
                    const top = userTop - containerTop;

                    const scrollPosition = container.scrollTop + top - offset;

                    container.scrollTo({
                        top: Math.max(0, scrollPosition),
                        behavior: "smooth"
                    });
                }
            }
        });
    };

    useEffect(() => {
        const timer = setTimeout(scrollToProcessingUser, 50);
        return () => clearTimeout(timer);
    }, [figureData]);

    useEffect(() => {
        if (socketData?.method !== "update_user_figure") return;

        const getUpdateScor = async () => {
            try {
                const res = await api().get(
                    `/figure/figure_brigade/user_scores/${socketData.application_figure_id}/${socketData.figure_id}`
                );

                const updatedUserId = res.data.user_id;
                const figureId = socketData.figure_id;
                const newDraw = res.data.draw;

                setFigureData(prev => ({
                    ...prev,
                    figure: prev?.figure?.map((el) =>
                        el?.figure_id === figureId
                            ? {
                                ...el,

                                // 👉 защита от отката назад
                                currentDraw: newDraw != null
                                    ? Math.max(el.currentDraw ?? 0, newDraw)
                                    : el.currentDraw,

                                users: el?.users?.map((user) => {
                                    const isUpdatedUser = user.user_id === updatedUserId;

                                    return {
                                        ...user,
                                        scores: isUpdatedUser ? res.data.scores : user.scores,
                                        result_figure: isUpdatedUser ? res.data.result_figure : user.result_figure,
                                        penalty: isUpdatedUser ? res.data.penalty : user.penalty,
                                    };
                                })
                            }
                            : el
                    )
                }));

                setUpdateInput(prev => !prev);

            } catch (e) {
                console.error(e);
                toast.error('Ошибка обновления');
            }
        };

        getUpdateScor();
    }, [socketData]);

    return (
        <div className={s.content}>
            <div id={"figure_content"} className={s.figure_content}>
                {figureData?.figure?.map((fig, ind_box) => {
                    const sort_data = fig.users?.slice()?.sort((a, b) => a.sort - b.sort)

                    return <div className={s.figure_box} key={fig?.figure_id}
                                ref={el => blockRefs.current[ind_box] = el}>
                        <div className={s.figure_box_header}>
                            <p className={s.figure_box_header_title}>{fig.figure_name}</p>
                            <p
                                className={classNames(
                                    s.figure_box_header_title,
                                    judgleStatus.coach_type_5?.find((f) => f.coach_type_number === fig.brigade_number)?.status === 'disconnect' && s.disconnect,
                                    judgleStatus.coach_type_5?.find((f) => f.coach_type_number === fig.brigade_number)?.status === 'connect' && s.connect,
                                )}
                                onDoubleClick={() => {
                                    setOpenDialogCustom(true)
                                    setCoachTypeId(5)
                                    setCoachTypeNumber(fig.brigade_number)
                                }}
                            >
                                {fig.brigade_name}
                            </p>
                            <p className={s.figure_box_header_title}>{fig.figure_start}</p>
                        </div>

                        <div className={s.figure_box_jud}>
                            <div></div>
                            <div>Jd 1</div>
                            <div>Jd 2</div>
                            <div>Jd 3</div>
                            <div>Jd 4</div>
                            <div>Jd 5</div>
                            <div>Jd 6</div>
                            <div>Jd 7</div>
                            <div style={{minWidth: '82px'}}>Total</div>
                            <div style={{minWidth: '62px'}}>Penalty</div>
                        </div>

                        <div className={s.figure_box_content}>
                            {sort_data?.map((user) => {

                                const isProcessing = fig.currentDraw != null
                                    ? user.draw === fig.currentDraw
                                    : user.is_processing_discipline_figure_id != null;

                                const sort_data_user = user?.scores?.slice()?.sort((a, b) => a?.number_coach - b?.number_coach)
                                const littleArray = Array.from({length: 7 - sort_data_user.length})

                                return <div className={s.figure_box_content_item}
                                            key={`user-${user.user_id}`}
                                            data-user-id={user.user_id}
                                >
                                    <div className={s.figure_box_content_item_top}>
                                        <Tooltip
                                            title={user?.is_not_started === 1 ? 'DNS' : user?.is_disqulified === 1 ? 'DSQ' : ''}
                                            placement="right"
                                        >
                                            <div
                                                className={s.figure_box_content_item_number}
                                                style={{
                                                    background: isProcessing
                                                        ? 'rgb(134, 183, 96)'
                                                        : (user?.is_not_started === 1 || user?.is_disqulified === 1)
                                                            ? 'rgba(255,0,0,.3)'
                                                            : '#ffffff'
                                                }}
                                            >
                                                <p style={{
                                                    color: isProcessing ? '#ffffff' : '#000000'
                                                }}>
                                                    {user?.draw}
                                                </p>
                                            </div>
                                        </Tooltip>

                                        <div className={s.figure_box_content_item_name}>
                                            <p>{user?.user_name}</p>
                                        </div>

                                        <div className={s.figure_box_content_item_city}>
                                            <p>{user?.user_command || 'Город'}</p>
                                        </div>
                                    </div>

                                    <div className={s.figure_box_content_item_sub}>
                                        <div style={{minWidth: '50px'}}></div>

                                        {sort_data_user.map((score) =>
                                            <InputBox
                                                index_box={ind_box}
                                                is_read={user?.is_disqulified === 1 || user?.is_not_started === 1}
                                                updateInput={updateInput}
                                                score={score}
                                                user_id={user.user_id}
                                                id={score.score_figure_id}
                                                value={score.value}
                                                key={`score-${score?.number_coach}`}
                                            />
                                        )}

                                        {littleArray.map((_, i) => <div key={i} style={{minWidth: '50px'}}/>)}

                                        <div style={{minWidth: '82px'}} className={s.score_full}>
                                            {user?.result_figure != null && !isNaN(+user.result_figure)
                                                ? Number(user.result_figure).toFixed(4)
                                                : ""}
                                        </div>

                                        <InputBox
                                            index_box={ind_box}
                                            updateInput={updateInput}
                                            id={user.user_id}
                                            value={user.penalty}
                                            penalty={true}
                                        />
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                })}
            </div>
        </div>
    );
});

export default FigureBox2;